import { Controller } from "@hotwired/stimulus";

/**
 * Auto Submit Controller
 * Submits its form as soon as a field changes (a toggle that saves itself).
 *
 * Usage:
 *   = form_with url: some_path, data: { controller: 'auto-submit' } do
 *     = check_box_tag :on, '1', true, data: { action: 'change->auto-submit#submit' }
 */
export default class extends Controller<HTMLFormElement> {
  submit(): void {
    this.element.requestSubmit();
  }
}
